import {
  Int32IdAndLabel,
  GuidIdCodeAndLabel,
  StationOrLocationItem,
  GuidIdAndLabel, BrandAndMarketListItem, SearchRuleOrderValue,
} from '../../../integrated-client/models';
import {DEFAULT_PAGE_SIZE} from "../../../utils/Constants";

export interface IAutocompleteObject {
  id: string
  code: string
  label: string
}

export interface IFiltersData {
  brandAndMarket?: BrandAndMarketListItem
  distributionChannel?: Int32IdAndLabel
  agency?: GuidIdCodeAndLabel
  agencyOnly?: boolean
  origin?: StationOrLocationItem
  supplier?: GuidIdAndLabel
  carrier?: GuidIdCodeAndLabel
  description?: string
  destination?: StationOrLocationItem
  relevance?: number | null
  showDeleted?: boolean
  showDisabled?: boolean
  orderByDescending?: boolean;
  orderValue?: SearchRuleOrderValue;
  offset: number
  limit: number
}

export class FiltersData implements IFiltersData {
  brandAndMarket?: BrandAndMarketListItem
  distributionChannel?: Int32IdAndLabel
  agency?: GuidIdCodeAndLabel
  agencyOnly?: boolean
  origin?: StationOrLocationItem
  supplier?: GuidIdAndLabel
  carrier?: GuidIdCodeAndLabel
  description?: string
  destination?: StationOrLocationItem
  relevance?: number
  showDeleted?: boolean
  showDisabled?: boolean
  orderByDescending?: boolean
  orderValue?: SearchRuleOrderValue
  offset: number
  limit: number

  constructor() {
    this.offset = 0;
    this.limit = DEFAULT_PAGE_SIZE;
  }

}
